import { AxiosStatic } from "axios";

import { DataExtract, parseDataExtractModel } from "./models";

export class DataExtractApi {
    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async createCustomer(customerId: string): Promise<DataExtract> {
        const response = await this.axios.post(`/api/customer/${customerId}/dataExtract`);
        return parseDataExtractModel(response.data as DataExtract);
    }

    public async createEmployee(customerId: string, employeeId: string): Promise<DataExtract> {
        const response = await this.axios.post(`/api/customer/${customerId}/employee/${employeeId}/dataExtract`);
        return parseDataExtractModel(response.data as DataExtract);
    }

    public async loadAll(): Promise<DataExtract[]> {
        const response = await this.axios.get("/api/dataExtract");
        return (response.data as DataExtract[]).map(parseDataExtractModel);
    }
}
